import {
  CLEAR_ORGANIZATION_EVENT_PARTICIPATIONS_DATA,
  ORGANIZATION_EVENT_PARTICIPATIONS_FAILURE,
  ORGANIZATION_EVENT_PARTICIPATIONS_REQUEST,
  OrganizationEventParticipationsActionTypes,
  OrganizationEventParticipationsState,
  SET_ORGANIZATION_EVENT_PARTICIPATIONS_EVENT_SORTED_DATA,
  SET_ORGANIZATION_EVENT_PARTICIPATIONS_USER_SORTED_DATA,
} from "./types";

/**
 * The initial state for the organization event participation
 * @type {OrganizationEventParticipationsState}
 * @property {OrganizationEventParticipationsData[]} organizationEventParticipationsData - The event participation data
 * @property {boolean} isLoading - The loading state
 */
export const initialOrganizationEventParticipationState: OrganizationEventParticipationsState =
  {
    eventSortedData: [],
    userSortedData: [],
    totalProgressPercentage: null,
    isLoading: false,
  };

/**
 * The organization event participation reducer.
 * @param {OrganizationEventParticipationsState} state - The organization event participation state
 * @param {OrganizationEventParticipationsActionTypes} action - The action to perform
 * @returns {OrganizationEventParticipationsState}
 */
export function organizationEventParticipationsReducer(
  state = initialOrganizationEventParticipationState,
  action: OrganizationEventParticipationsActionTypes
): OrganizationEventParticipationsState {
  switch (action.type) {
    case ORGANIZATION_EVENT_PARTICIPATIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ORGANIZATION_EVENT_PARTICIPATIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case SET_ORGANIZATION_EVENT_PARTICIPATIONS_EVENT_SORTED_DATA:
      return {
        ...state,
        eventSortedData: action.eventSortedData,
        totalProgressPercentage: action.totalProgressPercentage,
        isLoading: false,
      };
    case SET_ORGANIZATION_EVENT_PARTICIPATIONS_USER_SORTED_DATA:
      return {
        ...state,
        userSortedData: action.userSortedData,
        totalProgressPercentage: action.totalProgressPercentage,
        isLoading: false,
      };
    case CLEAR_ORGANIZATION_EVENT_PARTICIPATIONS_DATA:
      return {
        ...state,
        eventSortedData: [],
        userSortedData: [],
        totalProgressPercentage: null,
        isLoading: false,
      };
    default:
      return state;
  }
}
